module.exports = "<div class=story-meta> {{ story.category }} - Rated: {{ story.rating }} - {{ story.language }} - {{ story.genre }}<template v-if=\"story.subgenre_id > 0\">/{{ story.subgenre }}</template> - Chapters: {{ story.chapters }} - Words: {{ story.words }} - Updated: {{ story.date_updated }} - Published: {{ story.date_posted }} {{ story.charactors }} <template v-if=\"story.status_id == 2\">- Completed</template> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StorySmallMeta.vue
 ** module id = 79
 ** module chunks = 0
 **/